import { useEffect, useRef, useCallback } from "react";

let scriptLoaded = false;

function loadTurnstileScript() {
  if (scriptLoaded || document.getElementById("cf-turnstile-script")) {
    scriptLoaded = true;
    return;
  }
  const script = document.createElement("script");
  script.id = "cf-turnstile-script";
  script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
  scriptLoaded = true;
}

/**
 * Widget Cloudflare Turnstile en mode "explicit render".
 * Props:
 *   siteKey   — clé publique Cloudflare (obligatoire)
 *   onToken   — callback(token: string) appelé quand le challenge est validé
 *   onExpire  — callback() quand le token expire (reset requis)
 *   onError   — callback() en cas d'erreur widget
 */
export default function TurnstileWidget({ siteKey, onToken, onExpire, onError }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  const render = useCallback(() => {
    if (!containerRef.current || !window.turnstile || widgetIdRef.current !== null) return;
    widgetIdRef.current = window.turnstile.render(containerRef.current, {
      sitekey: siteKey,
      callback: onToken,
      "expired-callback": onExpire,
      "error-callback": onError,
      theme: "light",
      size: "normal",
    });
  }, [siteKey, onToken, onExpire, onError]);

  useEffect(() => {
    loadTurnstileScript();

    // Si l'API est déjà prête, on rend immédiatement
    if (window.turnstile) {
      render();
      return;
    }

    // Sinon on attend que le script se charge
    const interval = setInterval(() => {
      if (window.turnstile) {
        clearInterval(interval);
        render();
      }
    }, 100);

    return () => {
      clearInterval(interval);
      if (widgetIdRef.current !== null && window.turnstile) {
        try { window.turnstile.remove(widgetIdRef.current); } catch {}
        widgetIdRef.current = null;
      }
    };
  }, [render]);

  return <div ref={containerRef} className="flex justify-center" />;
}
